import { render } from "./ProgramDefiActivity.vue?vue&type=template&id=4bda7773&scoped=true"
import script from "./ProgramDefiActivity.vue?vue&type=script&lang=js"
export * from "./ProgramDefiActivity.vue?vue&type=script&lang=js"

import "./ProgramDefiActivity.vue?vue&type=style&index=0&id=4bda7773&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bda7773"],['__file',"resources/js/components/analytics/ProgramDefiActivity.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4bda7773"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4bda7773', __exports__)) {
    api.reload('4bda7773', __exports__)
  }
  
  module.hot.accept("./ProgramDefiActivity.vue?vue&type=template&id=4bda7773&scoped=true", () => {
    api.rerender('4bda7773', render)
  })

}


export default __exports__